export default {
    // 存当前用户表单信息
    SetUserFrom(state, data) {
        state.userFrom = data;
    },
    setToken(state) {
        state.token = localStorage.getItem('token');
    },
};